// extracted by mini-css-extract-plugin
export default {"saved":"Chip_saved__yrqP-","processed":"Chip_processed__FANUl"};